export const appUrl = {
    signin: 'signin',
    start: 'start-page',
}